<div class="sp-row__space">
  <div class="sp-row__align">
    <mat-icon
      class="sp-color__primary sp-hidden__before-md sp-cursor__pointer"
      (click)="onBackClick()">
      arrow_back
    </mat-icon>
    <h2 class="sp-margin__left sp-color__primary sp-hidden__before-md">{{ getShrinkedID() }}</h2>
    <h3 class="sp-margin__left sp-color__primary sp-hidden__after-md">{{ getShrinkedID() }}</h3>
  </div>

  <div class="sp-row__align">
    <mat-spinner
      *ngIf="is_read_running"
      color="accent"
      diameter="20"></mat-spinner>

    <app-buyer-details-navbar
      *ngIf="!is_read_running"
      (tab_change)="tab_change.emit($event)"></app-buyer-details-navbar>

    <button
      (click)="$event.stopPropagation()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent sp-margin__left"
      [matTooltip]="'Menu' | translate"
      [mat-menu-trigger-for]="buyers_actions_menu">
      <mat-icon> more_horiz </mat-icon>
    </button>

    <mat-menu #buyers_actions_menu="matMenu">
      <button
        (click)="onChatClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> chat </mat-icon>
        <span> {{ 'GENERAL.OPEN_CHAT_CTA' | translate }} </span>
      </button>

      <button
        (click)="onEditClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> create </mat-icon>
        <span> {{ 'BUYERS.EDIT_CTA' | translate }} </span>
      </button>

      <button
        (click)="onRequestsClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> list </mat-icon>
        <span> {{ 'GENERAL.SEE_REQUESTS_CTA' | translate }} </span>
      </button>

      <button
        (click)="onEditCreditCardClick(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> credit_card</mat-icon>
        <span> {{ 'BUYERS.EDIT_CREDIT_CARD_CTA' | translate }} </span>
      </button>

      <button
        (click)="onConfirmBuyerClick(); $event.stopPropagation()"
        [disabled]="!(!buyer?.is_confirmed || buyer?.confirmed_by)"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon
          *ngIf="!(buyer?.is_confirmed && buyer?.confirmed_by)"
          class="material-symbols-outlined sp-color__accent">
          check_circle_outline
        </mat-icon>
        <mat-icon
          *ngIf="buyer?.is_confirmed && buyer?.confirmed_by"
          class="material-symbols-outlined sp-color__accent">
          info
        </mat-icon>
        <span> {{ 'BUYERS.CONFIRM_USER_CTA' | translate }} </span>
      </button>

      <button
        (click)="onUnlockBuyerClick(); $event.stopPropagation()"
        [disabled]="!buyer?.blocked_at"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon class="material-symbols-outlined sp-color__accent"> lock_open </mat-icon>
        <span> {{ 'GENERAL.UNBLOCK_USER_CTA' | translate }} </span>
      </button>

      <button
        (click)="onToggleLockBuyer(); $event.stopPropagation()"
        class="sp-padding__vert"
        mat-menu-item>
        <mat-icon
          class="material-symbols-outlined sp-color__accent"
          [ngClass]="buyer?.blocked_by_admin ? 'sp-color__primary' : 'sp-color__accent'">
          {{ buyer?.blocked_by_admin ? 'lock' : 'lock_open' }}
        </mat-icon>
        <span> {{ 'BUYERS.TOGGLE_BLOCK_CTA' | translate }} </span>
      </button>
    </mat-menu>

    <button
      (click)="refresh.emit()"
      mat-icon-button
      [matTooltip]="'GENERAL.REFRESH_CTA' | translate"
      class="sp-icon__button sp-icon__button-dark sp-margin__left">
      <mat-icon class="material-symbols-outlined"> refresh </mat-icon>
    </button>
  </div>
</div>
